// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4f15b393","488":"c1965727","977":"122b75eb"}[chunkId] + ".chunk.js";
};